<template>
  <div class="row" v-on:mousemove="checkInactivityMoveMouse">
    <header-servico
      tipo="Acompanhamento"
      :loading="loading"
      page="paf"
      :familia="familia.id"
    />
    <load v-if="loading" message="Carregando acompanhamentos da Família" />
    <div v-else class="col-md-12">
      <div class="row">
        <div
          class="col-md-12"
          v-if="acompanhamento.status != status_final_id"
          v-html="acompanhamento ? getPrazo(acompanhamento.data_avaliacao) : ''"
        ></div>
      </div>
      <!--Tabela-->
      <div class="row">
        <SidebarServico @page="showPage" />

        <ModalVerificarPrivado
          :familia-id="familia.id"
          v-if="acompanhamento.privado == 1 && status_privado == false"
          @liberar="status_privado = true"
        />
        <div
          v-else
          class="col-md-9"
          v-on:mousemove="status_privado = !checkInactivity"
        >
          <header-familia :item="acompanhamento.familia" />

          <div v-if="page == 'acompanhamento'">
            <div class="card mb-0 shadow" v-if="historicoStatus == false">
              <div class="card-body">
                <div class="tab-content">
                  <div class="animate__animated animate__fadeIn">
                    <div class="row">
                      <div class="col-12">
                        <h4 class="font-weight-bold">
                          Gestão do Acompanhamento
                        </h4>
                      </div>
                      <HeaderAcompanhamento :acompanhamento="acompanhamento" />
                      <form-select
                        v-model="acompanhamento.servico_id"
                        label="Serviço"
                        grid="6"
                        :itens="servicos"
                        :required="true"
                        :disabled="
                          acompanhamento.editado == 1 || loadingServicos == true
                            ? true
                            : false
                        "
                        :loading="loadingServicos"
                      />
                      <form-select
                        v-model="acompanhamento.tecnico_id"
                        label="Técnico de referência"
                        :required="true"
                        grid="6"
                        :itens="listtecnicos"
                        :loading="loadingTecnicos"
                        :disabled="loadingTecnicos"
                      />
                      <form-calendar
                        v-model="acompanhamento.data_ingresso"
                        grid="3"
                        label="Data de início"
                        :required="true"
                      />
                      <form-calendar
                        v-model="acompanhamento.data_final"
                        grid="3"
                        label="Data Final"
                      />
                      <form-calendar
                        v-model="acompanhamento.data_avaliacao"
                        grid="3"
                        label="Data Avaliação"
                        :required="true"
                      />
                      <form-select
                        v-model="acompanhamento.periodicidade"
                        label="Periodicidade"
                        grid="3"
                        :itens="$root.arrays.acompanhamento_periodicidade"
                        :required="true"
                      />

                      <form-select
                          v-model="acompanhamento.pessoas"
                          :multiple="true"
                          label="Usuário(s)"
                          :itens="pessoas"
                          :required="true"
                          grid="12"
                          @input="aoAlterarPessoas"
                      />

                      <div
                          v-if="possuiDadosAnterioresSemIndividualizacao"
                          class="col-md-12 mt-3"
                      >
                          <div class="painel-dados-legados">
                              <div class="painel-dados-legados__cabecalho">
                                  <div class="painel-dados-legados__icone">
                                      <i class="mdi mdi-account-switch-outline"></i>
                                  </div>

                                  <div>
                                      <h5 class="painel-dados-legados__titulo">
                                          Informações pendentes de individualização
                                      </h5>

                                      <p class="painel-dados-legados__descricao">
                                          Este acompanhamento possui informações
                                          registradas anteriormente sem identificação
                                          da pessoa. Caso seja possível identificá-la,
                                          atribua os itens abaixo aos respectivos usuários.
                                      </p>
                                  </div>
                              </div>

                              <div
                                  v-if="dadosAnteriores.vulnerabilidades.length > 0"
                                  class="painel-dados-legados__grupo"
                              >
                                  <div class="painel-dados-legados__subtitulo">
                                      <i class="mdi mdi-shield-alert-outline"></i>
                                      Vulnerabilidades
                                  </div>

                                  <div class="painel-dados-legados__itens">
                                      <div
                                          v-for="situacaoId in
                                              dadosAnteriores.vulnerabilidades"
                                          :key="
                                              'vulnerabilidade-antiga-' +
                                              situacaoId
                                          "
                                          class="situacao-legada"
                                          :class="{
                                              'situacao-legada--atribuida':
                                                  situacaoFoiDistribuida(
                                                      'vulnerabilidades',
                                                      situacaoId
                                                  ),
                                          }"
                                      >
                                          <i
                                              v-if="
                                                  situacaoFoiDistribuida(
                                                      'vulnerabilidades',
                                                      situacaoId
                                                  )
                                              "
                                              class="mdi mdi-check-circle"
                                          ></i>

                                          <i
                                              v-else
                                              class="mdi mdi-clock-alert-outline"
                                          ></i>

                                          <span>
                                              {{
                                                  nomeSituacao(
                                                      situacaoId,
                                                      vulnerabilidades
                                                  )
                                              }}
                                          </span>

                                          <small>
                                              {{
                                                  situacaoFoiDistribuida(
                                                      "vulnerabilidades",
                                                      situacaoId
                                                  )
                                                      ? "Atribuída"
                                                      : "Pendente"
                                              }}
                                          </small>
                                      </div>
                                  </div>
                              </div>

                              <div
                                  v-if="dadosAnteriores.violencias.length > 0"
                                  class="painel-dados-legados__grupo"
                              >
                                  <div class="painel-dados-legados__subtitulo">
                                      <i class="mdi mdi-alert-octagon-outline"></i>
                                      Violências/Violações de direito
                                  </div>

                                  <div class="painel-dados-legados__itens">
                                      <div
                                          v-for="situacaoId in
                                              dadosAnteriores.violencias"
                                          :key="
                                              'violencia-antiga-' +
                                              situacaoId
                                          "
                                          class="situacao-legada"
                                          :class="{
                                              'situacao-legada--atribuida':
                                                  situacaoFoiDistribuida(
                                                      'violencias',
                                                      situacaoId
                                                  ),
                                          }"
                                      >
                                          <i
                                              v-if="
                                                  situacaoFoiDistribuida(
                                                      'violencias',
                                                      situacaoId
                                                  )
                                              "
                                              class="mdi mdi-check-circle"
                                          ></i>

                                          <i
                                              v-else
                                              class="mdi mdi-clock-alert-outline"
                                          ></i>

                                          <span>
                                              {{
                                                  nomeSituacao(
                                                      situacaoId,
                                                      violencias
                                                  )
                                              }}
                                          </span>

                                          <small>
                                              {{
                                                  situacaoFoiDistribuida(
                                                      "violencias",
                                                      situacaoId
                                                  )
                                                      ? "Atribuída"
                                                      : "Pendente"
                                              }}
                                          </small>
                                      </div>
                                  </div>
                              </div>

                              <div class="painel-dados-legados__rodape">
                                  <i class="mdi mdi-information-outline"></i>

                                  A individualização não é obrigatória neste momento.
                                  Os itens pendentes permanecerão em aberto e poderão
                                  ser atribuídos posteriormente.
                              </div>
                          </div>
                      </div>
                      
                      <div
                          v-for="pessoaSituacao in pessoaSituacoes"
                          :key="pessoaSituacao.usuario_id"
                          class="col-md-12 mt-3"
                      >
                          <div class="card border">
                              <div class="card-header">
                                  <strong>Usuário:</strong>
                                  <span v-html="nomePessoa(pessoaSituacao.usuario_id)"></span>
                              </div>

                              <div class="card-body">
                                  <div class="row">
                                      <form-select
                                          v-model="
                                              pessoaSituacao.vulnerabilidades
                                          "
                                          label="Vulnerabilidades"
                                          :multiple="true"
                                          :itens="vulnerabilidades"
                                          grid="12"
                                          :loading="
                                              loadingVulnerabilidades
                                          "
                                          :disabled="
                                              loadingVulnerabilidades
                                          "
                                          @input="individualizacaoAlterada = true"
                                      />

                                      <form-select
                                          v-model="
                                              pessoaSituacao.violencias
                                          "
                                          label="Violência/Violações de direito"
                                          :multiple="true"
                                          :itens="violencias"
                                          grid="12"
                                          :loading="loadingViolencias"
                                          :disabled="loadingViolencias"
                                          @input="individualizacaoAlterada = true"
                                      />
                                  </div>
                              </div>
                          </div>
                      </div>

                      <form-textarea-editor
                        v-model="acompanhamento.potencialidades"
                        label="Potencialidades"
                      />
                      <form-textarea-editor
                        v-model="acompanhamento.fragilidades"
                        label="Fragilidades"
                      />
                      <form-textarea-editor
                        v-model="acompanhamento.diagnostico"
                        label="Avaliação Técnica"
                        @onfocus="changeIsEditNow"
                        @onblur="changeIsEditNow"
                      />
                      <Meta
                        :acompanhamento="acompanhamento"
                        class="mb-3"
                      />

                      <form-textarea-editor
                        v-model="acompanhamento.estrategia"
                        label="Intervenção"
                        @onfocus="changeIsEditNow"
                        @onblur="changeIsEditNow"
                      />
                      <form-textarea-editor
                        v-model="acompanhamento.recursos_mobilizados"
                        label="Objetivos a serem atingidos"
                      />

                      <form-select
                        v-if="tecnicos"
                        v-model="acompanhamento.tecnicos"
                        label="Outros técnicos"
                        :multiple="true"
                        :itens="listtecnicos"
                      />
                    </div>

                    <div
                      class="row pt-4 px-0 d-flex justify-content-between align-items-center"
                    >
                      <div class="row pl-3">
                        <form-select
                          v-model="acompanhamento.status"
                          label="Status"
                          :itens="status"
                          @change="verificarStatus"
                          :loading="loadingStatus"
                          grid="7"
                          :ajuda="ajuda_status"
                        />
                        <form-toggle
                          grid="5"
                          class="mt-4"
                          v-model="acompanhamento.privado"
                          label="Sigilo?"
                        />
                      </div>
                      <div class="col-auto px-2 mt-2 text-right">
                        <a
                          class="router-link-exact-active active px-3"
                          @click="historicoStatus = true"
                        >
                          <i class="fas fa-history"></i>
                          Histórico de Status
                        </a>
                        <b-button
                          :title="$t('Visualizar e Imprimir')"
                          :to="
                            '/dashboard/acompanhamento/show/' +
                            acompanhamento.id
                          "
                          class="py-1"
                          size="sm"
                          type="button"
                          v-b-tooltip.hover
                          variant="primary"
                        >
                          <i class="mdi mdi-printer mdi-18px" />
                        </b-button>
                        <a
                          class="btn btn-primary"
                          @click="$bvModal.show('modal-auditoria')"
                          :title="$t('Auditoria')"
                          v-b-tooltip.hover
                        >
                          <i class="mdi mdi-timeline-clock-outline mdi-16px" />
                        </a>
                        <a
                          v-if="
                            $store.state.user.role_details.name == 'Admin' ||
                            $store.state.user.role_details.name ==
                              'Gestor(a)' ||
                            $store.state.user.id == acompanhamento.user_id
                          "
                          title="Remanejar"
                          class="btn btn-warning py-2"
                          @click="
                            $bvModal.show('modal-remanejar-acompanhamento')
                          "
                        >
                          <i class="fas fa-exchange-alt mdi-18px" />
                          {{ $t("Remanejar") }}
                        </a>
                        <button
                          class="btn btn-success btn-submit"
                          data-style="zoom-in"
                          type="submit"
                          @click="submit"
                          :disabled="
                            acompanhamento.status == status_final_id
                              ? true
                              : false
                          "
                        >
                          <i class="mdi mdi-content-save" />
                          {{ $t("Salvar") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0 shadow card-body" v-else>
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Gestão do Acompanhamento</h4>
                    </div>
                    <HeaderAcompanhamento :acompanhamento="acompanhamento" />
                    <HistoricoStatus
                      @voltar="historicoStatus = false"
                      :id="acompanhamento.id"
                      :familia="acompanhamento.familia_id"
                      :status="status_acompanhamento"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Anexo :acompanhamento="acompanhamento" v-if="page == 'anexo'" />
          <Atendimento
            :acompanhamento="acompanhamento"
            v-if="page == 'atendimento'"
          />
          <Atividade
            :acompanhamento="acompanhamento"
            v-if="page == 'atividade'"
          />
          <Avaliacao
            :status="status_acompanhamento"
            @save="verificarStatus"
            :acompanhamento="acompanhamento"
            @atualizarPagina="page = $event"
            v-if="page == 'avaliacao'"
          />
          <Comentario
            :acompanhamento="acompanhamento"
            v-if="page == 'comentario'"
          />
          <Desligamento
            :status="status"
            :acompanhamento="acompanhamento"
            v-if="page == 'desligamento'"
          />
          <Encaminhamento
            :acompanhamento="acompanhamento"
            v-if="page == 'encaminhamento'"
          />
          <HistoricoEstrategia
            :acompanhamento="acompanhamento"
            v-if="page == 'estrategia'"
          />
          <HistoricoDiagnostico
            :acompanhamento="acompanhamento"
            v-if="page == 'diagnostico'"
          />
          <HistoricoAvaliacao
            :acompanhamento="acompanhamento"
            v-if="page == 'historico_avaliacao'"
          />
          <Oficio :acompanhamento="acompanhamento" v-if="page == 'oficio'" />
        </div>
      </div>
    </div>
    <status-historico
      model="Paf"
      modulo="PAF"
      titulo_modulo="ACOMPANHAMENTO"
      :id="acompanhamento.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_acompanhamento"
      @submit="submit"
    />
    <remanejar-acompanhamento :acompanhamento="acompanhamento" />
    <ModalAuditoria
      servico="acompanhamento"
      :servico_id="acompanhamento.id"
    />
  </div>
</template>

<style scoped> 

.painel-dados-legados {
    overflow: hidden;
    border: 1px solid #dbe4ee;
    border-left: 4px solid #3f7fc4;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 8px rgba(31, 45, 61, 0.07);
}

.painel-dados-legados__cabecalho {
    display: flex;
    align-items: flex-start;
    padding: 18px 20px;
    background-color: #f5f9fd;
    border-bottom: 1px solid #e3ebf3;
}

.painel-dados-legados__icone {
    display: flex;
    flex: 0 0 42px;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    margin-right: 14px;
    border-radius: 50%;
    background-color: #e3effb;
    color: #2e6da8;
    font-size: 23px;
}

.painel-dados-legados__titulo {
    margin: 0 0 5px;
    color: #263746;
    font-size: 16px;
    font-weight: 600;
}

.painel-dados-legados__descricao {
    max-width: 850px;
    margin: 0;
    color: #667788;
    line-height: 1.5;
}

.painel-dados-legados__grupo {
    padding: 16px 20px 5px;
}

.painel-dados-legados__subtitulo {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color: #34495e;
    font-weight: 600;
}

.painel-dados-legados__subtitulo i {
    margin-right: 7px;
    color: #5c7083;
    font-size: 18px;
}

.painel-dados-legados__itens {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.situacao-legada {
    display: inline-flex;
    align-items: center;
    padding: 7px 10px;
    border: 1px solid #d8e0e8;
    border-radius: 6px;
    background-color: #f7f8fa;
    color: #4d5c68;
}

.situacao-legada > i {
    margin-right: 7px;
    color: #cc7a00;
    font-size: 17px;
}

.situacao-legada > small {
    margin-left: 9px;
    color: #9a650c;
    font-weight: 600;
}

.situacao-legada--atribuida {
    border-color: #b8dfc7;
    background-color: #f0faf4;
    color: #27633e;
}

.situacao-legada--atribuida > i,
.situacao-legada--atribuida > small {
    color: #2f8a50;
}

.painel-dados-legados__rodape {
    margin-top: 15px;
    padding: 11px 20px;
    border-top: 1px solid #e5ebf1;
    background-color: #fafbfd;
    color: #6d7c89;
    font-size: 13px;
}

.painel-dados-legados__rodape i {
    margin-right: 5px;
    color: #3f7fc4;
}

</style>


<script>
import ModalVerificarPrivado from "./includes/ModalVerificarPrivado";
import SidebarServico from "./includes/SidebarServico";
import HeaderAcompanhamento from "./HeaderAcompanhamento";
import HistoricoStatus from "./HistoricoStatus";
import Anexo from "./includes/abas/Anexo";
import Atendimento from "./includes/abas/Atendimento";
import Atividade from "./includes/abas/Atividade";
import Avaliacao from "./includes/abas/Avaliacao";
import Comentario from "./includes/abas/Comentario";
import Desligamento from "./includes/abas/Desligamento";
import Encaminhamento from "./includes/abas/Encaminhamento";
import HistoricoDiagnostico from "./includes/abas/HistoricoDiagnostico";
import HistoricoEstrategia from "./includes/abas/HistoricoEstrategia";
import HistoricoAvaliacao from "./includes/abas/HistoricoAvaliacao";
import Meta from "./includes/abas/Meta";
import Oficio from "./includes/abas/Oficio";
import ModalAuditoria from "../../../../../resources/js/dashboard/components/widgets/ModalAuditoria";
export default {
  components: {
    ModalVerificarPrivado,
    HeaderAcompanhamento,
    SidebarServico,
    Anexo,
    Atendimento,
    Atividade,
    Avaliacao,
    Comentario,
    Desligamento,
    Encaminhamento,
    HistoricoEstrategia,
    HistoricoDiagnostico,
    HistoricoAvaliacao,
    HistoricoStatus,
    Meta,
    Oficio,
    ModalAuditoria,
  },
  name: "Edit",
  data() {
    return {
      page: "acompanhamento",
      statusAtual: "",
      statusAnterior: "",
      acompanhamento: {},
      tecnicos: [],
      unidades: {},
      tipos: {},
      servicos: [],
      familia: {},
      status_acompanhamento: {},
      status_final_id: "",
      status_aberto_id: "",
      files: [],
      loading: true,
      progressCompleted: 0,
      status_privado: false,
      historicoStatus: false,
      status: [],
      inativo: false,
      vulnerabilidades: [],
      violencias: [],
      model: "Paf",
      loadingTecnicos: false,
      loadingServicos: false,
      loadingVulnerabilidades: false,
      loadingViolencias: false,
      loadingStatus: false,
      isEditNow: false,
      pessoaSituacoes: [],
      individualizacaoAlterada: false,
      possuiIndividualizacao: false,  
      dadosAnteriores: {
          vulnerabilidades: [],
          violencias: [],
      },
      ajuda_status: `<b>ABERTO:</b> O status aberto é indicado quando o usuário da plataforma registra o Plano de Acompanhamento Familiar, no caso esse status aponta que foi iniciado um registro, e posterior será possível a continuidade do registro, além do gerenciamento e indicação de outros status ( continuidade do acompanhamento);<br><br>
            <b>EM ANDAMENTO:</b> O status Em Andamento é registrado sempre que o usuário da Plataforma gerencia o acompanhamento de aberto para em andamento, como meio de registrar que o grupo familiar está em acompanhamento ativo;<br><br>
            <b>FINALIZADO:</b> O Status Finalizado é indicado sempre que o usuário da Plataforma,após gerenciar um Plano de Acompanhamento Familiar, atualiza o status para finalizado informando os motivos pelo qual está encerrando a intervenção. Os motivos podem ser: superação da problemática; retorno para cidade de origem (recambio), não adesão ao serviço; mudança de cidade; óbito, encaminhamento para outros serviços, acompanhamento/avaliação finalizado, e outros motivos que culminaram na finalização do acompanhamento.<br><br>
            <b>INATIVO:</b>O status inativo é atribuído a um registro quando não há mais necessidade de mantê-lo por várias razões. Normalmente, isso acontece devido à duplicação de informações ou à ausência de dados relevantes. Quando um registro é marcado como inativo, isso indica que ele não está mais em uso ativo e não será mais atualizado ou mantido.`,
    };
  },
  mounted() {
    this.getAcompanhamento();
    // this.saveAutomatic(); Remover salvamento automático
    this.$bvModal.show("verificar-acompanhamento-privado");
    if (this.acompanhamento.is_owner == false) {
      this.$router.push(
        `/dashboard/acompanhamento/show/${this.acompanhamento.id}`
      );
    }
  },
  computed: {

    situacoesAnterioresPendentes() {
        return {
            vulnerabilidades:
                this.dadosAnteriores.vulnerabilidades.filter(
                    (situacaoId) =>
                        !this.situacoesDistribuidas
                            .vulnerabilidades
                            .includes(Number(situacaoId))
                ),

            violencias:
                this.dadosAnteriores.violencias.filter(
                    (situacaoId) =>
                        !this.situacoesDistribuidas
                            .violencias
                            .includes(Number(situacaoId))
                ),
        };
    },

    situacoesDistribuidas() {
        const resultado = {
            vulnerabilidades: [],
            violencias: [],
        };

        const registros = Array.isArray(
            this.pessoaSituacoes
        )
            ? this.pessoaSituacoes
            : [];

        registros.forEach((registro) => {
            resultado.vulnerabilidades =
                resultado.vulnerabilidades.concat(
                    this.normalizarIds(
                        registro.vulnerabilidades
                    )
                );

            resultado.violencias =
                resultado.violencias.concat(
                    this.normalizarIds(
                        registro.violencias
                    )
                );
        });

        resultado.vulnerabilidades = [
            ...new Set(resultado.vulnerabilidades),
        ];

        resultado.violencias = [
            ...new Set(resultado.violencias),
        ];

        return resultado;
    },

    listtecnicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: elem.value,
      }));
      return map;
    },

    possuiDadosAnterioresSemIndividualizacao() {
        return (
            this.situacoesAnterioresPendentes
                .vulnerabilidades.length > 0 ||
            this.situacoesAnterioresPendentes
                .violencias.length > 0
        );
    },

    pessoas() {
        const familiares =
            this.familia &&
            Array.isArray(this.familia.familiares)
                ? this.familia.familiares
                : [];

        return familiares.map((pessoa) => ({
            id: pessoa.id,
            searchTerms: [pessoa.nome_completo, pessoa.nome_social],
            value: pessoa.nome_social
                ? pessoa.nome_social +
                  " <b>" +
                  pessoa.idade +
                  " ano(s)</b>"
                : pessoa.nome_completo +
                  " <b>" +
                  pessoa.idade +
                  " ano(s)</b>",
        }));
    },

    checkInactivity() {
      if (this.$root.isIdle == true) {
        this.status_privado = false;
        this.$bvModal.show("verificar-acompanhamento-privado");
      }
      return this.$root.isIdle;
    },
  },
  methods: {

    situacaoFoiDistribuida(tipo, situacaoId) {
        const distribuidas =
            this.situacoesDistribuidas[tipo];

        if (!Array.isArray(distribuidas)) {
            return false;
        }

        return distribuidas.includes(
            Number(situacaoId)
        );
    },

    nomeSituacao(situacaoId, opcoes) {
        const lista = Array.isArray(opcoes)
            ? opcoes
            : [];

        const situacao = lista.find(
            (item) =>
                Number(item.id) === Number(situacaoId)
        );

        if (!situacao) {
            return `Situação #${situacaoId}`;
        }

        return (
            situacao.value ||
            situacao.descricao ||
            situacao.nome ||
            `Situação #${situacaoId}`
        );
    },

    carregarIndividualizacao(dados) {
        const registros =
            Array.isArray(dados.pessoa_situacoes)
                ? dados.pessoa_situacoes
                : [];

        let pessoasSelecionadas =
            this.normalizarIds(dados.pessoas);

        if (pessoasSelecionadas.length === 0) {
            pessoasSelecionadas =
                this.normalizarIds(
                    dados.pessoas_objetos
                );
        }

        const vulnerabilidadesAntigas =
            this.normalizarIds(
                dados.vulnerabilidades
            );

        const violenciasAntigas =
            this.normalizarIds(
                dados.violencias
            );

        const agrupados =
            this.agruparPessoaSituacoes(
                registros
            );

        const possuiIndividualizacao =
            registros.length > 0;

        /*
        * Guarda os dados gerais somente quando o PAF
        * ainda não possui individualização.
        */
        this.dadosAnteriores = {
            vulnerabilidades:
                vulnerabilidadesAntigas,

            violencias:
                violenciasAntigas,
        };

        this.$set(
            dados,
            "pessoas",
            pessoasSelecionadas
        );

        this.acompanhamento = dados;

        this.pessoaSituacoes =
            pessoasSelecionadas.map(
                (usuarioId) => {
                    if (agrupados[usuarioId]) {
                        return agrupados[
                            usuarioId
                        ];
                    }

                    return {
                        usuario_id: usuarioId,
                        vulnerabilidades: [],
                        violencias: [],
                    };
                }
            );

        this.possuiIndividualizacao =
            possuiIndividualizacao;

        this.individualizacaoAlterada =
            false;
    },

    verificarSituacoesAntigasPendentes() {
        const pessoaSituacoes =
            this.montarPessoaSituacoes();

        const vulnerabilidadesDistribuidas =
            this.normalizarIds(
                pessoaSituacoes.reduce(
                    (resultado, item) =>
                        resultado.concat(
                            item.vulnerabilidades
                        ),
                    []
                )
            );

        const violenciasDistribuidas =
            this.normalizarIds(
                pessoaSituacoes.reduce(
                    (resultado, item) =>
                        resultado.concat(
                            item.violencias
                        ),
                    []
                )
            );

        return {
            vulnerabilidades:
                this.dadosAnteriores.vulnerabilidades.filter(
                    (situacaoId) =>
                        !vulnerabilidadesDistribuidas.includes(
                            Number(situacaoId)
                        )
                ),

            violencias:
                this.dadosAnteriores.violencias.filter(
                    (situacaoId) =>
                        !violenciasDistribuidas.includes(
                            Number(situacaoId)
                        )
                ),
        };
    },

    changeIsEditNow(status) {
      this.isEditNow = status;
      //console.log("teste " + status);
    },
    verificarStatusEmAndamento() {
      if (this.getStatusNome(this.acompanhamento.status) != "ABERTO") {
        let index = this.status.findIndex((x) => x.value === "ABERTO");
        this.status.splice(index, 1);
      }
    },
    getStatusNome(id) {
      const result = this.status.filter((elem) => elem.id == id);
      return result[0] ? result[0].value : null;
    },
    checkInactivityMoveMouse() {
      if (this.acompanhamento.privado == 1) {
        if (this.$root.isIdle == true) {
          this.status_privado = false;
          this.$bvModal.show("verificar-acompanhamento-privado");
        }
        return this.$root.isIdle;
      } else {
        return false;
      }
    },

    normalizarIds(valores) {
        if (
            valores === null ||
            valores === undefined ||
            valores === ""
        ) {
            return [];
        }

        if (typeof valores === "string") {
            try {
                valores = JSON.parse(valores);
            } catch (error) {
                valores = valores.split(",");
            }
        }

        if (!Array.isArray(valores)) {
            valores = [valores];
        }

        const ids = valores
            .map((item) => {
                if (
                    item !== null &&
                    typeof item === "object"
                ) {
                    return Number(item.id);
                }

                return Number(item);
            })
            .filter((id) => Number.isInteger(id) && id > 0);

        return [...new Set(ids)];
    },

    nomePessoa(usuarioId) {
        const pessoa = this.pessoas.find(
            (item) =>
                Number(item.id) === Number(usuarioId)
        );

        return pessoa
            ? pessoa.value
            : `Usuário #${usuarioId}`;
    },

    aoAlterarPessoas() {
        this.sincronizarPessoasSituacoes();
        this.individualizacaoAlterada = true;
    },

    sincronizarPessoasSituacoes() {
        const usuariosSelecionados =
            this.normalizarIds(
                this.acompanhamento.pessoas
            );

        this.pessoaSituacoes =
            usuariosSelecionados.map((usuarioId) => {
                const existente =
                    this.pessoaSituacoes.find(
                        (item) =>
                            Number(item.usuario_id) ===
                            Number(usuarioId)
                    );

                if (existente) {
                    return existente;
                }

                return {
                    usuario_id: usuarioId,
                    vulnerabilidades: [],
                    violencias: [],
                };
            });
    },

    agruparPessoaSituacoes(registros) {
        const agrupados = {};

        registros.forEach((registro) => {
            const usuarioId = Number(
                registro.usuario_id
            );

            if (!agrupados[usuarioId]) {
                agrupados[usuarioId] = {
                    usuario_id: usuarioId,
                    vulnerabilidades: [],
                    violencias: [],
                };
            }

            const situacaoId = Number(
                registro.situacao_id
            );

            if (
                registro.tipo ===
                "VULNERABILIDADE"
            ) {
                agrupados[
                    usuarioId
                ].vulnerabilidades.push(situacaoId);
            }

            if (registro.tipo === "VIOLENCIA") {
                agrupados[
                    usuarioId
                ].violencias.push(situacaoId);
            }
        });

        Object.keys(agrupados).forEach(
            (usuarioId) => {
                agrupados[
                    usuarioId
                ].vulnerabilidades = [
                    ...new Set(
                        agrupados[
                            usuarioId
                        ].vulnerabilidades
                    ),
                ];

                agrupados[usuarioId].violencias = [
                    ...new Set(
                        agrupados[
                            usuarioId
                        ].violencias
                    ),
                ];
            }
        );

        return agrupados;
    },

    montarPessoaSituacoes() {
        this.sincronizarPessoasSituacoes();

        return this.pessoaSituacoes.map(
            (item) => ({
                usuario_id: Number(
                    item.usuario_id
                ),

                vulnerabilidades:
                    this.normalizarIds(
                        item.vulnerabilidades
                    ),

                violencias: this.normalizarIds(
                    item.violencias
                ),
            })
        );
    },

    montarPayloadIndividualizado(
        preservarDadosAntigos = false
    ) {
        const pessoaSituacoes =
            this.montarPessoaSituacoes();

        const pessoas = this.normalizarIds(
            this.acompanhamento.pessoas
        );

        const vulnerabilidadesDistribuidas =
            this.normalizarIds(
                pessoaSituacoes.reduce(
                    (resultado, item) =>
                        resultado.concat(
                            item.vulnerabilidades
                        ),
                    []
                )
            );

        const violenciasDistribuidas =
            this.normalizarIds(
                pessoaSituacoes.reduce(
                    (resultado, item) =>
                        resultado.concat(
                            item.violencias
                        ),
                    []
                )
            );

        /*
        * Identifica os dados antigos que ainda não foram
        * atribuídos a nenhuma pessoa.
        */
        const vulnerabilidadesPendentes =
            preservarDadosAntigos
                ? this.dadosAnteriores.vulnerabilidades.filter(
                      (situacaoId) =>
                          !vulnerabilidadesDistribuidas.includes(
                              Number(situacaoId)
                          )
                  )
                : [];

        const violenciasPendentes =
            preservarDadosAntigos
                ? this.dadosAnteriores.violencias.filter(
                      (situacaoId) =>
                          !violenciasDistribuidas.includes(
                              Number(situacaoId)
                          )
                  )
                : [];

        /*
        * Mantém nos campos gerais tanto os itens distribuídos
        * quanto os dados antigos que continuam pendentes.
        */
        const vulnerabilidadesGerais =
            this.normalizarIds(
                vulnerabilidadesDistribuidas.concat(
                    vulnerabilidadesPendentes
                )
            );

        const violenciasGerais =
            this.normalizarIds(
                violenciasDistribuidas.concat(
                    violenciasPendentes
                )
            );

        return {
            ...this.acompanhamento,

            pessoas,

            pessoa_situacoes:
                pessoaSituacoes,

            vulnerabilidades:
                vulnerabilidadesGerais,

            violencias:
                violenciasGerais,
        };
    },

    criarFormData(dados) {
        const formData = new FormData();

        const camposJson = [
            "pessoas",
            "vulnerabilidades",
            "violencias",
            "pessoa_situacoes",
        ];

        Object.keys(dados).forEach((key) => {
            const valor = dados[key];

            if (valor === undefined) {
                return;
            }

            if (camposJson.includes(key)) {
                formData.append(
                    key,
                    JSON.stringify(valor || [])
                );

                return;
            }

            formData.append(
                key,
                valor === null ? "" : valor
            );
        });

        return formData;
    },

    saveAutomatic() {
      setTimeout(() => {
        var meta = this.$route.meta.controller;
        if (
          this.page == "acompanhamento" &&
          this.acompanhamento.status != this.status_aberto_id &&
          this.acompanhamento.status != this.status_final_id
        ) {
          if (meta == "PafController") {
            if (this.isEditNow == false) {
              this.submit(true);
            }
            this.saveAutomatic();
          }
        }
      }, 30000);
    },
    showPage(page) {
      this.page = page;
    },
    submitFile(files) {
      this.files = files;
    },
    getVulnerabilidades() {
      this.loadingVulnerabilidades = true;
      axios.get(`api/dashboard/get/vulnerabilidades`).then((response) => {
        this.vulnerabilidades = response.data;
        this.loadingVulnerabilidades = false;
      });
    },
    getViolencias() {
      this.loadingViolencias = true;
      axios.get(`api/dashboard/get/violencias`).then((response) => {
        this.violencias = response.data;
        this.loadingViolencias = false;
      });
    },
    getAcompanhamento() {
      this.loading = true;
      axios
        .get(`api/dashboard/acompanhamentos/${this.$route.params.id}`)
        .then((response) => {
          this.carregarIndividualizacao(
              response.data.data
          );
          this.statusAnterior = this.acompanhamento.status;
          this.familia = this.acompanhamento.familia_id;
          this.$route.query.familia_id = this.acompanhamento.familia_id.id;

          this.getViolencias();
          this.getVulnerabilidades();
          this.getStatusFinais();
          this.getTecnicos();
          this.getStatus();
          this.getServicos();
          this.getUnidades();
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          //console.log(this.$route.query.familia_id);
          if (this.$route.query.familia_id) {
            this.$router.push(
              `/dashboard/acompanhamentos/${this.$route.query.familia_id}`
            );
          } else {
            this.$router.push(`/dashboard/familias`);
          }
        });
    },
    verificarStatus(status) {
      this.statusAtual = status;
      this.acompanhamento.status = this.statusAtual;
      const result = this.status_acompanhamento.filter(
        (item) => item.id == status
      );

      if (result[0].final == 1) {
        //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
        this.$bvModal.show(`status-historico-${this.model}`);
      }
    },
    getUnidades() {
      axios
        .get(`api/dashboard/unidades/get/externas/PLANTAO`)
        .then((response) => {
          this.unidades = response.data;
        });
    },
    getStatusFinalizado() {
      const result = this.status_acompanhamento.filter(
        (status) => status.descricao == "FINALIZADO"
      );
      return result[0].id;
    },
    getStatusFinais() {
      axios
        .post(`api/dashboard/get/status/finais`, {
          model: "Paf",
          module: "PAF",
        })
        .then((response) => {
          this.status_acompanhamento = response.data;

          this.status_final_id = this.getStatusFinalizado();
        });
    },
    getTecnicos() {
      this.loadingTecnicos = true;
      axios.get(`api/dashboard/tecnicos/get`).then((response) => {
        this.tecnicos = response.data;
        this.loadingTecnicos = false;
      });
    },
    getTipos() {
      axios.get(`api/dashboard/acompanhamento/tipos`).then((response) => {
        this.tipos = response.data;
      });
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/status/acompanhamento`)
        .then((response) => {
          this.status = response.data;

          this.status.filter((elem) => {
            if (elem.value == "ABERTO") {
              this.status_aberto_id = elem.id;
            }
          });
        })
        .finally(() => {
          this.verificarStatusEmAndamento();
          this.loadingStatus = false;
        });
    },
    getServicos() {
      this.loadingServicos = true;
      axios.get(`api/dashboard/acompanhamento/servicos`).then((response) => {
        this.servicos = response.data;
        this.loadingServicos = false;
      });
    },
    setTipos(tipos) {
      this.tipos = tipos;
    },
    submit(automatico = false) {
        const historico_save =
            automatico === "historico"
                ? "historico"
                : false;

        /*
        * Prepara os campos obrigatórios para atualização.
        */
        this.acompanhamento.familia_id =
            this.familia.id;

        this.acompanhamento.automatico =
            automatico === true;

        /*
        * Formata a data antes do envio.
        */
        if (this.acompanhamento.data_ingresso) {
            this.acompanhamento.data_ingresso =
                moment(
                    this.acompanhamento.data_ingresso
                ).format("YYYY-MM-DD");
        }

        /*
        * Monta:
        *
        * - pessoas;
        * - pessoa_situacoes;
        * - vulnerabilidades gerais;
        * - violências gerais.
        *
        * O true preserva os dados gerais dos PAFs antigos
        * quando nenhuma individualização foi realizada.
        */
        const dados =
            this.montarPayloadIndividualizado(true);

        const formData =
            this.criarFormData(dados);

        let ladda = null;

        /*
        * O salvamento de histórico ocorre sem o botão
        * principal, por isso não inicia o Ladda.
        */
        if (historico_save !== "historico") {
            const botao =
                document.querySelector(".btn-submit");

            if (botao) {
                ladda = Ladda.create(botao);
                ladda.start();
            }
        }

        axios
            .post(
                `api/dashboard/update/acompanhamento`,
                formData
            )
            .then((response) => {
                /*
                * Algumas rotas retornam:
                *
                * response.data.data
                *
                * Outras retornam diretamente:
                *
                * response.data
                */
                const dadosAtualizados =
                    response.data && response.data.data
                        ? response.data.data
                        : response.data;

                /*
                * Recarrega os campos individualizados
                * caso a controller devolva o acompanhamento.
                */
                if (
                    dadosAtualizados &&
                    typeof dadosAtualizados === "object"
                ) {
                    this.carregarIndividualizacao(
                        dadosAtualizados
                    );
                }

                if (historico_save !== "historico") {
                    this.$snack.success({
                        button: false,
                        text:
                            "Acompanhamento atualizado " +
                            "com sucesso.",
                    });
                }
            })
            .catch((error) => {
                /*
                * Caso seu interceptor global já apresente
                * a mensagem do backend, este bloco pode
                * permanecer somente no console.
                */
                console.error(
                    "Erro ao atualizar acompanhamento:",
                    error
                );

                if (historico_save !== "historico") {
                    const mensagem =
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                            ? error.response.data.message
                            : "Não foi possível atualizar o acompanhamento.";

                    this.$snack.danger({
                        button: false,
                        text: mensagem,
                    });
                }
            })
            .finally(() => {
                if (ladda) {
                    ladda.stop();
                }

                this.progressCompleted = 0;
                this.files = [];
            });
    },
    renderAlert(mensagem, tipo) {
      return `<div class="alert alert-${tipo} alert-dismissible fade show" role="alert">${mensagem}<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>`;
    },
    getPrazo(data) {
      if (data) {
        var data_final = moment(data);
        var data_atual = moment();
        var prazo = data_final.diff(data_atual, "days");

        if (prazo > 3) {
          return this.renderAlert(
            `O prazo para avaliação é de <strong>${prazo} dia(s) </strong>`,
            "info"
          );
        } else if (prazo > 1 && prazo < 3) {
          return this.renderAlert(
            `O prazo para avaliação é de <strong>${prazo} dia(s) </strong>`,
            "warning"
          );
        } else if (prazo == 0) {
          return this.renderAlert(
            `<strong>Último dia para avaliar! </strong>`,
            "danger"
          );
        } else if (prazo < 0) {
          return this.renderAlert(
            `Sua avaliação está <strong>${
              prazo * -1
            }</strong> dia(s) em atraso!`,
            "danger"
          );
        }
      }
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
